import "../scss/style.sass";

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

window.cookieStorage = {
  getItem(key) {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].split("=");
      if (key == cookie[0].trim()) {
        return decodeURIComponent(cookie[1]);
      }
    }
    return null;
  },
  setItem(key, value) {
    document.cookie = key+' = '+encodeURIComponent(value)+'; path=/';
  }
}

Alpine.plugin(persist);
window.Alpine = Alpine;
Alpine.start();

import "./_modal";
import "./_recall-form";
import "./events/_formSubmissions";
import "./funnel/_scrollStep";
